import { useMediaQuery } from '@mantine/hooks';

import Desktop from './NavBarSearchBar';
import Mobile from './Mobile';

const SearchBar = () => {
  const matches = useMediaQuery('(min-width: 62em)');

  if (matches) {
    return <Desktop />;
  }

  return <Mobile />;
};
export default SearchBar;
